import React, { useState } from "react";
import { useParams, useNavigate, useSearchParams } from "react-router-dom";
import { useEffect } from "react";
import PageHeader from "../components/ui/PageHeader";
import ProposalList from "../components/proposals/ProposalList";
import ProposalForm from "../components/proposals/ProposalForm";
import ProposalDetail from "../components/proposals/ProposalDetail";
import { Box, Button, Dialog, DialogContent, useTheme } from "@mui/material";
import { Add } from "@mui/icons-material";

const ProposalsPage = () => {
  const { proposalId } = useParams();
  const navigate = useNavigate();
  const theme = useTheme();
  const [showForm, setShowForm] = useState(false);
  const [editingProposal, setEditingProposal] = useState(null);
  const [refreshKey, setRefreshKey] = useState(0);
  const [searchParams] = useSearchParams();

  useEffect(() => {
    if (searchParams.get("new") === "true") {
      setShowForm(true);
    }
  }, []);
  const handleView = (proposal) => {
    navigate(`/proposals/${proposal.id}`);
  };

  const handleEdit = (proposal) => {
    setEditingProposal(proposal);
    setShowForm(true);
  };

  const handleSave = () => {
    setShowForm(false);
    setEditingProposal(null);
    setRefreshKey((k) => k + 1);
  };

  if (proposalId) {
    return <ProposalDetail proposalId={proposalId} onEdit={handleEdit} />;
  }

  return (
    <Box>
      <PageHeader
        title="Propuestas"
        action={
          <Button
            variant="contained"
            startIcon={<Add />}
            onClick={() => {
              setEditingProposal(null);
              setShowForm(true);
            }}
            sx={{
              background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.dark} 100%)`,
              borderRadius: "12px",
              textTransform: "none",
              fontWeight: 600,
              boxShadow: "none",
              "&:hover": {
                boxShadow: `0 4px 12px ${theme.palette.primary.main}40`,
                filter: "brightness(1.05)",
              },
            }}
          >
            Nueva Propuesta
          </Button>
        }
      />
      <ProposalList key={refreshKey} onView={handleView} onEdit={handleEdit} />

      <Dialog
        key={editingProposal?.id || "new"}
        open={showForm}
        onClose={() => {
          setShowForm(false);
          setEditingProposal(null);
        }}
        maxWidth="md"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: "24px",
            maxHeight: "90vh",
          },
        }}
      >
        <DialogContent sx={{ p: 0 }}>
          <ProposalForm
            proposal={editingProposal}
            onSave={handleSave}
            onCancel={() => {
              setShowForm(false);
              setEditingProposal(null);
            }}
          />
        </DialogContent>
      </Dialog>
    </Box>
  );
};

export default ProposalsPage;
